import React, { useState } from 'react'

export default function SingelTodo(props) {
    const [Completed, setCompleted] = useState(false)


    const handelcomplete = () => {
        if (Completed) {
            setCompleted(false);

        }
        else {
            setCompleted(true);

        }
    }
    return (
        <div className={`${Completed === true ? "bg-green-500 text-white" : props.theme === "dark" ? "bg-gray-800 text-gray-100" : 'bg-gray-100 text-gray-900'} m-auto p-6 mb-6`} key={props.sno}>
            <div className="float-right">
                <button className='cursor-pointer ml-2 mr-2' onClick={() => { handelcomplete(); }}>{Completed === true ? "UnComplete" : "Complete"}</button>
                <button className='cursor-pointer ml-2 mr-2' onClick={() => { props.handeldelete(props.sno); }} >Delete</button>
            </div>
            <h1 className="text-2xl font-bold">
                {props.title}
            </h1>
            <h1 className="text-xl font-light">
                {props.description}

            </h1>
        </div>)
}
